import React, { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import CloseIcon from '@mui/icons-material/Close';
import ImageUploader from '../modules/ModuleForm/ImageUploader';

const emptyForm = {
    type: 'Text',
    topText: '',
    imageURL: '',
    title: '',
    description: '',
    buttonText: '',
    buttonLink: '',
    isActive: true,
    sequence: '',
};

const AssistanceCardModal = ({ open, onClose, onSubmit, card }) => {
    const [form, setForm] = useState(emptyForm);
    const isEdit = Boolean(card?._id);

    useEffect(() => {
        if (!open) return;
        if (card) {
            setForm({
                type: card.type || 'Text',
                topText: card.topText || '',
                imageURL: card.imageURL || '',
                title: card.title || '',
                description: card.description || '',
                buttonText: card.buttonText || '',
                buttonLink: card.buttonLink || '',
                isActive: card.isActive !== false,
                sequence: card.sequence != null ? String(card.sequence) : '',
            });
        } else {
            setForm(emptyForm);
        }
    }, [open, card]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const seqRaw = String(form.sequence ?? '').trim();
        const seqNum = seqRaw === '' ? undefined : Number(seqRaw);
        const { sequence: _omitSeq, ...formRest } = form;
        const payload = {
            ...formRest,
            title: String(form.title || '').trim(),
            description: String(form.description || '').trim(),
            buttonText: String(form.buttonText || '').trim(),
            buttonLink: String(form.buttonLink || '').trim(),
            topText: form.type === 'Text' ? String(form.topText || '').trim() : '',
            imageURL: form.type === 'Image' ? String(form.imageURL || '').trim() : '',
            ...(seqRaw !== '' && Number.isFinite(seqNum) ? { sequence: seqNum } : {}),
        };
        if (isEdit) payload._id = card._id;
        onSubmit(payload);
    };

    const inputStyle = {
        width: '100%',
        padding: '10px 12px',
        border: '1px solid #dbe3f0',
        borderRadius: 10,
        fontSize: '0.9rem',
        outline: 'none',
        boxSizing: 'border-box'
    };

    const labelStyle = { display: 'block', marginBottom: 6, fontWeight: 600, fontSize: '0.8rem', color: '#1a2744' };

    return (
        <Modal open={open} onClose={onClose} className="backdrop td500 zi4 df jcc aic">
            <div className="bg1 shadow br15px bsbb" style={{ width: '92%', maxWidth: 560, maxHeight: '90vh', overflow: 'auto', padding: '1.5rem', position: 'relative', outline: 'none' }}>
                <button type="button" onClick={onClose} className="pa cp" style={{ top: 12, right: 12, border: 'none', background: 'transparent' }}>
                    <CloseIcon />
                </button>
                <h2 className="fs1-25rem fw600 c15 mb1rem" style={{ paddingRight: 32 }}>{isEdit ? 'Edit Assistance Card' : 'Create Assistance Card'}</h2>

                <form onSubmit={handleSubmit}>
                    <label style={labelStyle}>Sequence</label>
                    <input type="number" style={{ ...inputStyle, marginBottom: 12 }} value={form.sequence} onChange={(e) => setForm((f) => ({ ...f, sequence: e.target.value }))} placeholder="Leave empty for auto (append after highest)" />

                    <label style={labelStyle}>Type</label>
                    <select style={{ ...inputStyle, marginBottom: 12 }} value={form.type} onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))}>
                        <option value="Text">Text</option>
                        <option value="Image">Image</option>
                    </select>

                    {form.type === 'Text' ? (
                        <>
                            <label style={labelStyle}>Top Text</label>
                            <input style={{ ...inputStyle, marginBottom: 12 }} value={form.topText} onChange={(e) => setForm((f) => ({ ...f, topText: e.target.value }))} placeholder="Category / top text" />
                        </>
                    ) : (
                        <div style={{ marginBottom: 12 }}>
                            <ImageUploader
                                imageURL={form.imageURL}
                                onImageChange={(url) => setForm((f) => ({ ...f, imageURL: url }))}
                                label="Image"
                            />
                        </div>
                    )}

                    <label style={labelStyle}>Title</label>
                    <input required style={{ ...inputStyle, marginBottom: 12 }} value={form.title} onChange={(e) => setForm((f) => ({ ...f, title: e.target.value }))} />

                    <label style={labelStyle}>Description</label>
                    <textarea style={{ ...inputStyle, minHeight: 80, resize: 'vertical', marginBottom: 12 }} value={form.description} onChange={(e) => setForm((f) => ({ ...f, description: e.target.value }))} />

                    <div className="df" style={{ gap: 10, marginBottom: 12 }}>
                        <div style={{ flex: 1 }}>
                            <label style={labelStyle}>Button Text</label>
                            <input style={inputStyle} value={form.buttonText} onChange={(e) => setForm((f) => ({ ...f, buttonText: e.target.value }))} />
                        </div>
                        <div style={{ flex: 1 }}>
                            <label style={labelStyle}>Active</label>
                            <select style={inputStyle} value={form.isActive ? 'yes' : 'no'} onChange={(e) => setForm((f) => ({ ...f, isActive: e.target.value === 'yes' }))}>
                                <option value="yes">Yes</option>
                                <option value="no">No</option>
                            </select>
                        </div>
                    </div>

                    <label style={labelStyle}>Button Link</label>
                    <input style={{ ...inputStyle, marginBottom: 18 }} value={form.buttonLink} onChange={(e) => setForm((f) => ({ ...f, buttonLink: e.target.value }))} placeholder="https://..." />

                    <div className="df jcfe" style={{ gap: 10 }}>
                        <button type="button" className="cp p1rem br8px bg44" onClick={onClose}>Cancel</button>
                        <button type="submit" className="cp p1rem br8px c1 fw600" style={{ background: 'linear-gradient(135deg, #2563eb, #1d4ed8)', border: 'none' }}>
                            {isEdit ? 'Save changes' : 'Create'}
                        </button>
                    </div>
                </form>
            </div>
        </Modal>
    );
};

export default AssistanceCardModal;
